import { Navigate, Outlet } from "react-router-dom";

export default function PrivateRoute({ component: Component, ...rest }) {
  const isLogged = localStorage.getItem("token");
  return isLogged ? <Outlet /> : <Navigate to="/" />;
}
